var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-header"},[_c('router-link',{staticClass:"slide-item-content",attrs:{"to":{ path: '/' }}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/images/logo.png")}})]),_vm._v(" "),_c('img',{class:{
      jnrmobile: _vm.isphone,
      jnrpc: _vm.isphone == false
    },attrs:{"src":require("../assets/images/jnr.png")}}),_vm._v(" "),_c('img',{class:{
      jslmobile: _vm.isphone,
      jslpc: _vm.isphone == false
    },attrs:{"src":require("../assets/images/930.png")}}),_vm._v(" "),_c('img',{staticClass:"banner",attrs:{"src":require("../assets/images/baner1.png")}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4224bdd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 